import { render, staticRenderFns } from "./jumlahKematian.vue?vue&type=template&id=145cb3c4&scoped=true&"
import script from "./jumlahKematian.vue?vue&type=script&lang=js&"
export * from "./jumlahKematian.vue?vue&type=script&lang=js&"
import style0 from "./jumlahKematian.vue?vue&type=style&index=0&id=145cb3c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cb3c4",
  null
  
)

export default component.exports